define('DisplayShippingType.View', [
    'SC.Configuration',
    'display_shipping_type.tpl',
    'jQuery',
    'Backbone',
    'underscore'
],
function DisplayShippingTypeView(
    Configuration,
    template,
    jQuery,
    Backbone,
    _
  ) {
    'use strict';

    var outboundShipModeItemFieldId = (Configuration.get('displayShippingTypeOutboundShipModeItemFieldId') || 'custitem_outbound_ship_mode');

    return Backbone.View.extend({
        events: {
            'mouseover [data-action="popover"]': 'openPopOver'
        },
        template: template,
        // @method initialize Override default method to attach model's change event to re-render
        // @param {ProductLine.Stock.View.Initialize.options} options
        // @return {Void}
        initialize: function initialize() {
            this.model.on('change', this.render, this);
        },
        closePopover: function closePopover(link) {
            // close mouseout
            link.on('mouseout', function onMouseOut(e) {
                e.preventDefault();
                link.popover('hide');
            });

            // TODO: close for mobile?
            // close for mobile
            // this.$el.one('click', '[data-type="close-popover"]', function oneClick(e) {
            //     e.preventDefault();
            //     link.popover('hide');
            // });
        },
        openPopOver: function openPopover(e) {
            var $link;

            e.preventDefault();
            e.stopPropagation();

            $link = jQuery(e.target);

            $link.popover({
                trigger: 'manual',
                html: true
            }).popover('toggle');

            // add more close popover
            this.closePopover($link);
        },
        // @method destroy Override default method to detach from model's change event
        // @return {Void}
        destroy: function destroy() {
            Backbone.View.prototype.destroy.apply(this, arguments);
            this.model.off('change', this.render, this);
        },

        // @method getContext
        getContext: function getContext() {
            var item = this.model.getItem();
            var shippingId = item.get(outboundShipModeItemFieldId) ? item.get(outboundShipModeItemFieldId) : '';
            var shippingTypes = Configuration.get('displayShippingType');
            var currentShipping = shippingTypes && _(shippingTypes).findWhere({
                shippingId: shippingId
            });

            return {
                currentShipping: currentShipping
            };
        }
    });
});

